/**
 * Forbrukerrådet - Kommunetesten
 * @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
 * @author Anders Evenrud <anders.evenrud@copyleft.no>
 */

/*!
 * Copyright (c) Forbrukerrådet
 */
import 'whatwg-fetch' // Polyfill for fetch
import 'intersection-observer' // Polyfill for lazy image loader
import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSearch,
  faAngleDown,
  faAngleUp,
  faCaretDown,
  faCaretUp,
  faPlus,
  faMinus,
  faSync,
  faSort,
  faTimes,
  faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons'

import App from './App.vue'
import router from './router'
import store from './store'
import links from './mixins/links'
import visuals from './mixins/visuals'
import './assets/styles.scss'

library.add(faSearch)
library.add(faAngleDown)
library.add(faAngleUp)
library.add(faCaretDown)
library.add(faCaretUp)
library.add(faPlus)
library.add(faMinus)
library.add(faSync)
library.add(faSort)
library.add(faTimes)
library.add(faExternalLinkAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.mixin(links)
Vue.mixin(visuals)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#kommunetesten-new')
